import { Button } from "primereact/button";
import React, { useState, useEffect, useRef, useCallback } from "react";
import "./styles.css";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";

const BannerCarousel = ({ items = [], style = {}, timeToChangeImg = 6 }) => {
  const filteredItems = items.filter((item) => item && Object.keys(item).length > 0);

  const bannerItems = filteredItems.slice(0, filteredItems.length);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const autoPlayRef = useRef(null);

  // Slide anterior
  const handlePrev = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? bannerItems.length - 1 : prevIndex - 1));

    setTimeout(() => setIsTransitioning(false), 500);
  };

  // Callback para navegar para o slide seguinte
  const handleNext = useCallback(() => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => (prevIndex === bannerItems.length - 1 ? 0 : prevIndex + 1));

    setTimeout(() => setIsTransitioning(false), 500);
  }, [isTransitioning, bannerItems, setIsTransitioning, setCurrentIndex]);

  // Eventos touch
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      // Swiped left
      handleNext();
    }

    if (touchStart - touchEnd < -50) {
      // Swiped right
      handlePrev();
    }
  };

  // Auto play
  useEffect(() => {
    const play = () => {
      autoPlayRef.current = setTimeout(() => {
        handleNext();
      }, timeToChangeImg * 1000);
    };

    play();
    return () => {
      if (autoPlayRef.current) {
        clearTimeout(autoPlayRef.current);
      }
    };
  }, [currentIndex, handleNext]);

  const generateImageUrl = (item) => {
    if (item?.cloudinary)
      return cloudinaryInstance.image(item.bgImg).resize(fill().width(1200).height(400)).toURL();

    return item.bgImg;
  };

  return (
    <div className="relative w-full overflow-hidden">
      {/*Container */}
      <div
        className="relative primary-banner-responsive"
        style={style}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Carousel items */}
        {bannerItems.map((item, index) => (
          <a
            key={index}
            href={item?.urlDestination ? item?.urlDestination : "#"}
            target="_blank"
            rel="noreferrer"
            className={`absolute top-0 left-0 w-full h-full flex items-center justify-center transition-transform transition-duration-500 transition-ease-in-out ${
              index === currentIndex
                ? "translate-x-0"
                : index < currentIndex
                ? "-translate-x-100"
                : "translate-x-100"
            }`}
            aria-label={item?.alt || "Banner link"}
            style={{
              backgroundImage: `url(${generateImageUrl(item)})`,
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              pointerEvents: item?.urlDestination ? "auto" : "none",
              cursor: item?.urlDestination ? "pointer" : "default",
            }}
          >
            <span className="sr-only" style={{ display: "none" }}>
              {item?.alt || "Banner"}
            </span>
          </a>
        ))}
      </div>

      {/* Navegação */}
      <Button
        style={{ top: "50%", left: "2rem", transform: "translateY(-50%)", zIndex: 1 }}
        className="absolute border-none p-no-outline navigation-button"
        icon="pi pi-chevron-left"
        onClick={handlePrev}
        aria-label="Previous slide"
      ></Button>

      <Button
        style={{ top: "50%", right: "2rem", transform: "translateY(-50%)", zIndex: 1 }}
        className="absolute navigation-button border-none p-no-outline"
        icon="pi pi-chevron-right"
        onClick={handleNext}
        aria-label="Next slide"
      ></Button>
    </div>
  );
};

export default BannerCarousel;
